module.exports = __webpack_public_path__ + "img/ok.98989091.svg";